import React from "react"

import classNames from "classnames/bind"
import styles from "../../styles/Question.module.scss"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { withTranslation, Trans } from "react-i18next"
import i18n from "../../i18n/i18n"

import { setAnswer } from "../../store/general"

import { questionList } from "../../constants/question"

class QuestionTemplate extends React.Component {
  setValueAndGoToNext = (value) => {
    const { qIndex, dispatch, goToNext, history } = this.props

    // n번 질문에 대한 답변 설정
    dispatch(setAnswer(qIndex, value))

    if (qIndex < 11) goToNext()
    else history.push("/loading")
  }

  render() {
    const { qIndex, t } = this.props

    return (
      <>
        <div className={cn("q-text")}>
          <Trans i18nKey={`question.q${qIndex}.question`}>
            질문
            <br />
          </Trans>
        </div>
        <ul className={cn("answers")}>
          <li
            className={cn("answer-item")}
            onClick={() => {
              this.setValueAndGoToNext(1)
            }}
          >
            <Trans i18nKey={`question.q${qIndex}.answer1`}>
              a1
              <br />
            </Trans>
          </li>
          <li
            className={cn("answer-item")}
            onClick={() => {
              this.setValueAndGoToNext(-1)
            }}
          >
            <Trans i18nKey={`question.q${qIndex}.answer2`}>
              a2
              <br />
            </Trans>
          </li>
        </ul>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  answer: state.general.answer,
})

const cn = classNames.bind(styles)

export default withRouter(connect(mapStateToProps)(withTranslation()(QuestionTemplate)))
